module.exports = __webpack_public_path__ + "4439a1cefdce40f17a2aa1fc9f791bc9.MP3";